import Globalize from '@sprinx/globalize';
import forLocale from '../utils/forLocale';
var localeVal = {};
/**
 * @returns {string}
 */

var timeIsAmPm = function timeIsAmPm() {
  return forLocale(localeVal, function (val) {
    /* istanbul ignore next */
    if (typeof val !== 'boolean') {
      var timeformat = Globalize.locale().main('dates/calendars/gregorian/timeFormats/short');
      val = timeformat.includes('a');
    }

    return !!val;
  });
};

export default timeIsAmPm;